import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import TablaDetalleCuenta from "./tablaDetallesCreditoAdicional";
import { Input, Textarea } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";

export const CreditoAdicional = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const anioefis = JSON.parse(localStorage.getItem("efiscalanio"));
  // const idusuario = JSON.parse(localStorage.getItem('idusuario'));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  // const espiritu = JSON.parse(localStorage.getItem('espiritu'));

  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState([]);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [tituloapro, setTituloapro] = useState("");
  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [codigo, setCodigo] = useState(0);
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [montoCredito, setMontoCredito] = useState(0.0);
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const txtFecha = useRef();
  const txtFechaAprobacion = useRef();
  const txtObservacion = useRef();
  const txtNp = useRef();
  const txtCodigo = useRef();

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La fecha del credito adicional no es valida",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (
      new Date(txtFecha.current.value).getFullYear() !== anioefis
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtFechaAprobacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La fecha de aprobación del credito adicional no es valida",
        icono: "informacion",
      });
      sigue = false;
      txtFechaAprobacion.current.focus();
    } else if (
      new Date(
        txtFechaAprobacion.current.value.replace("-", ",")
      ).getFullYear() !== anioefis
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "El año de aprobación no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFechaAprobacion.current.focus();
    } else if (txtObservacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Observación no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la(s) cuentas",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      let datoscue = [];

      for (let i = 0; i < data.length; i++) {
        datoscue.push({
          m_nIdMov: props.operacion === 1 ? 0 : data[i].idmovimiento,
          m_cCodCta: data[i].cuenta,
          m_nMonto: data[i].monto,
          m_nMontoDis: data[i].disponible,
        });
      }

      setBody({
        operacion: props.operacion,
        idcredito:
          props.operacion === 1 ? 0 : parseInt(txtCodigo.current.value),
        idefi: idefiscal,
        fecha: txtFecha.current.value,
        fechaapro: txtFechaAprobacion.current.value,
        montocredito: montoCredito,
        observacion: txtObservacion.current.value.trim(),
        datoscuenta: datoscue,
      });

      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar este Credito Adicional?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar este Credito Adicional?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/actualizarcreditoadicional`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El Credito Adicional " +
                response.data.valret +
                " fue Creado Correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El Credito Adicional " +
                txtCodigo.current.value +
                " fue Modificado Correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El Credito Adicional " +
                txtCodigo.current.value +
                " fue Eliminado Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setActivate(false);
    setChek(0);
    setValida([]);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setTicomp(null);
    setBody(null);
    setCodigo(0);
    setTituloapro("");
    setActivo(true);
    setMontoCredito(0.0);
  };

  const handleCloseSi = () => {
    if (
      props.operacion === 1 ||
      props.operacion === 2 ||
      props.operacion === 3
    ) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const BaseDatos = (data) => {
    if (data.length > 0) {
      setActivo(false);
      setValida(1);
      setValida(1);
      let total = 0.0;
      for (let i = 0; i < data.length; i++) {
        total = parseFloat(total) + parseFloat(data[i].monto);
      }

      setMontoCredito(
        Math.round(parseFloat(total) * Math.pow(10, 4)) / Math.pow(10, 4)
      );
    } else {
      setActivo(true);
      setValida(0);
    }
    setData(data);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setActivo(false);
          setValues(props.creditoadi);
          setDatospre(props.creditodet);
          txtObservacion.current.value = props.creditoadi.observacion;
          txtFecha.current.value = moment.utc(props.creditoadi.fecha).format(
            "YYYY-MM-DD"
          );
          txtFechaAprobacion.current.value = moment.utc(
            props.creditoadi.fechaaprob
          ).format("YYYY-MM-DD");
          txtCodigo.current.value = props.creditoadi.idcreditoadi;
        } else {
          txtObservacion.current.value = "";
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
          txtFechaAprobacion.current.value =
            moment.utc(fechaSistema).format("YYYY-MM-DD");
          txtCodigo.current.value = "";
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 4
              ? "Consulta. Credito Adicional"
              : operacion === 2
              ? "Reversar. Credito Adicional"
              : operacion === 3
              ? "Credito Adicional"
              : "Incluir. Credito Adicional"}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <input type="hidden" ref={txtNp} />

        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap gap-2 border-azul rounded">
          <legend className="float-none m-0 w-auto">Datos</legend>

          <div className="col-2 m-0 p-0">
            <Input
              label="Código:"
              name="observacion"
              disabled={true}
              defaultValue={
                props.aprobaciones
                  ? props.aprobaciones.idaprobaciones.trim()
                  : ""
              }
              id="inputDireccion"
              ref={txtCodigo}
            />
          </div>

          <div className="col-3 m-0 p-0">
            <Input
              label="Fecha:"
              type="date"
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              defaultValue={
                props.aprobaciones && props.aprobaciones.fecha !== ""
                  ? moment.utc(props.aprobaciones.fecha).format("YYYY-MM-DD")
                  : moment.utc(fechaSistema).format("YYYY-MM-DD")
              }
              id="inputDireccion"
              ref={txtFecha}
            />
          </div>

          <div className="col-3 m-0 p-0">
            <Input
              label="Fecha de Aprobación:"
              type="date"
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              defaultValue={
                props.aprobaciones && props.aprobaciones.fecha !== ""
                  ? moment.utc(props.aprobaciones.fecha).format("YYYY-MM-DD")
                  : moment.utc(fechaSistema).format("YYYY-MM-DD")
              }
              id="inputDireccion"
              ref={txtFechaAprobacion}
            />
          </div>

          <div className="col-12 m-0 p-0">
            <Textarea
              label="Observación"
              style={{ height: 70 }}
              autocomplete="off"
              name="observacion"
              onChange={onChange}
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              defaultValue={
                props.aprobaciones
                  ? props.aprobaciones.observaciones.trim()
                  : ""
              }
              placeholder="Descripción de la Observación"
              id="inputDireccion"
              ref={txtObservacion}
            />
          </div>
        </fieldset>

        <fieldset className="col-12 m-0 p-2 border-azul rounded">
          <legend className="float-none m-0 w-auto">
            Detalle de Cuenta(s)
          </legend>
            <TablaDetalleCuenta
              data={BaseDatos}
              datarecords={datospre}
              operacion={operacion}
            />
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton onClick={onChangeValidar} disabled={props.operacion === 4 ? true : activo}>
            Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
